// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__nGG_Z","info":"styles_info__0M41F","warning":"styles_warning___wvU1","danger":"styles_danger__KCfHJ","success":"styles_success__N8Xgk"};